import {message, ConfigProvider,Button, Col, Input, Popconfirm, Row, Tooltip, Modal, Table, Pagination } from 'antd';

import { sendHttpPostRequest } from '../../../api/http-request';
import React, { useState, useEffect,useRef} from "react";
import Cookies from 'js-cookie';

import Draggable  from "react-draggable";
import idataCodingTableStyles from "../../common/global-styles/idatacoding.module.less";
import myStyles from "./menu-edit.module.less"
import { BACKEND_API_URL } from '../../../constants/constants'


import Qs from 'qs';
import GlobalCss from '@/global.module.less'
import axios from 'axios';
import * as constants from '../../../constants/constants';


import zhCN from 'antd/lib/locale/zh_CN';

import {CloseCircleOutlined, SearchOutlined} from '@ant-design/icons';
import {
    DragDropContext,
    Droppable,
    Draggable as DndDraggable
  } from 'react-beautiful-dnd';
import MenuOutlined from '@ant-design/icons/lib/icons/MenuOutlined';

import TextArea from 'antd/lib/input/TextArea';
import { Link, useHistory } from 'react-router-dom';
interface Module {
      id:number,
      name:string
  
}


// 通过路由组件额外添加参数信息到表中
interface Props {
    menu_id: any //默认的大纲对象
}
const taskTypeMap = new Map([[1, '实训'],  [6, '纯讲义']]);
/** 模块化的大纲编辑组件，输入一个大纲对象，进行编辑可通过回调函数获取编辑后的大纲信息 */

export const MenuEdit: React.FC<Props> = (props: Props) => {
    const {menu_id} = props

    console.log(menu_id)
    const history = useHistory();

    const [menuName, setMenuName] = useState("");//大纲名称
    const [menuDesp, setMenuDesp] = useState("");//大纲描述
    const [menuDirectory, setMenuDirectory] = useState( null as any);//大纲目录

    const currentTaskId  =  useRef( null as any);//记录输入的任务ID
    const currentTask =  useRef( null as any);//记录当前任务信息

    const selectedTasks = useRef( null as any);//待添加的任务记录

    const currentChapterId =  useRef( null as any);//记录输入的章ID
    const currentChapter =  useRef( null as any);//记录当前章
    const currentChapterInd =  useRef( null as any);//记录当前章索引

    const selectedChapter = useRef( null as any);//待添加的章节记录


    const [chapterResult, setChapterResult] = useState([] as any[]);  // 章节搜索结果页


    const [taskListResult, setTaskListResult] = useState([] as any[]);  // 当前显示的任务搜索
    const [taskResultSum, setTaskResultSum] = useState(0);  // 搜索返回的任务结果数
    const [totalTaskCount, setTotalTaskCount] = useState(0);  // 搜索返回的总任务结果数
    const queryTaskContent = useRef('');  // 记录任务搜索串
    const queryTaskSource = useRef('2');  // 来源 1-个人  2-OAM创建（系统）
    const taskOrder = useRef('');  // 排序升序降序
    const taskOrderBy = useRef('');  // 排序列
    const taskPage = useRef(1);  // 记录当前的页数
    const taskPageSize = useRef(10);  // 记录当前每页展示数量
 

    const queryChapterContent = useRef('');  // 记录章节搜索串
    const chapterPage = useRef(1);  // 记录当前的页数
    const chapterPageSize = useRef(10);  // 记录当前每页展示数量
    const [chapterResultSum, setChpaterResultSum] = useState(0);  // 搜索返回的章节结果数


    const typeFilters = useRef([]);  // 类型过滤选项
    const difficultyFilters = useRef([]);  // 难易程度过滤选项

    /**
     * 查询任务列表
     */
     const queryTaskList = () => {
        sendHttpPostRequest(
            'exercise/api/oam_query_exercise_list/',
            {
                sessionid: Cookies.get("sessionid"),
                sid: Cookies.get("sessionid"),
                
                query_type: 1,
                query: queryTaskContent.current,
                page: taskPage.current,
                pagesize: taskPageSize.current,
                order: taskOrder.current,
                order_by: taskOrderBy.current,
                type: JSON.stringify(typeFilters.current),
                difficulty: JSON.stringify(difficultyFilters.current),
                //create_time: createTime.current,
                source: queryTaskSource.current
            },
            queryTaskListCallback
        )
    }

    /**
     * 查询任务列表回调
     * @param response
     */
    const queryTaskListCallback = (response: any) => {
        // console.log(response)
        message.destroy();
        if (response.code == -100) {
            // 未登录
            window.location.href = '/oam_login?next=oam_task';
        } else if (response.is_ok == true) {
            // 成功
            setTaskListResult(response.exercise_list);
            setTaskResultSum(response.total_sum);
            setTotalTaskCount(response.total_count);
        } /*else if (response.code == -501) {
            // 权限不足
            window.location.href = '/oam_login?next=oam_task';
        } */else {
            message.error("查询任务失败~");
        }
    }




     /** 以下是添加章弹出框显示用到的变量和函数 */
     const [isAddChapterModalVisible, setIsAddChapterModalVisible] = useState(false)
     const [isAddTaskModalVisible, setIsAddTaskModalVisible] = useState(false)

     const draggleRef = useRef<HTMLDivElement | null>(null)
   
     const [bounds,setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
     const [disabled,setDisabled] = useState(true)
   
     const onStart = (event:any, uiData:any) => {
       const { clientWidth, clientHeight } = window?.document?.documentElement;
       const targetRect= draggleRef?.current?.getBoundingClientRect();
       if(targetRect){
         setBounds( {
           left: -targetRect?.left + uiData?.x,
           right: clientWidth - (targetRect?.right - uiData?.x),
           top: -targetRect?.top + uiData?.y,
           bottom: clientHeight - (targetRect?.bottom - uiData?.y),
         }
       )
       }
     }
   
     /** 选择了某一章 */
     const rowChapterSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
          currentChapterId.current = selectedRowKeys[0];
          selectedChapter.current = selectedRows[0];
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
        getCheckboxProps: (record: any) => ({
          disabled: menuDirectory.filter((item)=>(item.id == record.id)).length > 0
          //name: record.name,
        }),
      };

           /** 选择了任务,keyi */
     const rowTaskSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
          selectedTasks.current = selectedRows;
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
        getCheckboxProps: (record: any) => ({
          disabled: checkContainsTaskInMenu(record.id) > 0
          //name: record.name,
        }),
      };


       // 表格列
    const chapter_cols: any = [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 60,
            align: 'center',
        },
        {
            title: "名称",
            dataIndex: "name",
            key: "name",
            width: 150,
            align: 'left',
            ellipsis: true,
        },
        {
            title: "描述",
            dataIndex: "description",
            key: "description",
            width: 100,
            align: 'left',
            ellipsis: true,
        },
        {
            title: '创建者',
            dataIndex: 'creator_name',
            key: 'creator_name',
            width: 180,
            align: 'center',
            render: (t, r, i) => {
                return (
                <Row align="middle" justify="center" style={{ gap: '5px' }}>
                    <Col>
                    <img
                        className={GlobalCss.avatar}
                        src={BACKEND_API_URL + r.creator_avatar}
                        alt=""
                    />
                    </Col>
                    <Col>{r.creator_name}</Col>
                </Row>
                )
            },
        },
        {
            title: '创建时间',
            dataIndex: 'create_time',
            key: 'create_time',
            width: 200,
            align: 'left',
        },
    ]

     
     const handleAddChapterOk = () => { //添加章
         //window.open(`/exercise-edit?exercise_type=${selectedType}`);
         setIsAddChapterModalVisible(false);
         
         const newChapters = [...menuDirectory];

         newChapters.push({id: selectedChapter.current?.id ,name: selectedChapter.current?.name, description:selectedChapter.current?.description,tasks:[]});
      
         setMenuDirectory(
            newChapters
        ); 
         saveMenu();
         
     }
 
     const showAddChapterModal = () => {

        setIsAddChapterModalVisible(true);
     };
 
     const handleAddChapterCancel = () => {
        setIsAddChapterModalVisible(false)
     }

     const handleAddTaskOk = () => { //添加任务
        //window.open(`/exercise-edit?exercise_type=${selectedType}`);
        setIsAddTaskModalVisible(false);
        //onAddedTaskConfirm();

        const newChapters = [...menuDirectory];

        selectedTasks.current.map(row=>{
            newChapters[currentChapterInd.current].tasks.push({id:row.id,name:row.title});
        })
        
        
        setMenuDirectory(
            newChapters.filter(group => group.tasks.length >= 0 )
        ); 

        saveMenu();
        
    }

    const showAddTaskModal = () => {
       setIsAddTaskModalVisible(true);
    };

    const handleAddTaskCancel = () => {
       setIsAddTaskModalVisible(false)
    }

     
    useEffect(() => {
        queryMenu();
        queryChapterList();
        queryTaskList();
    }, [])

    /**
     * 查询章节列表
     */
     const queryChapterList = () => {
        sendHttpPostRequest(
            'course/api/oam_query_chapter_list',
            {
                sessionid: Cookies.get("sessionid"),
                page: chapterPage.current,
                pageSize: chapterPageSize.current,
                query: queryChapterContent.current
            },
            queryChapterListCallback
        )
    }

    /**
     * 查询章节列表回调
     * @param response
     */
    const queryChapterListCallback = (response: any) => {
        // console.log(response)
        message.destroy();
        if (response.code == -100) {
            // 未登录
            window.location.href = '/oam_login?next=oam_chapter';
        } else if (response.is_ok == true) {
            // 成功
            setChapterResult(response.query_list);
            setChpaterResultSum(response.total_sum);
            //setTotalCount(response.total_count);
            //setSysCount(response.sys_count);
            //setUserCount(response.user_count);
            //setOnlineCount(response.online_count);
        }// else if (response.code == -501) {
            // 权限不足
            //window.location.href = '/oam_login?next=oam_chapter';
        //} else {
            //message.error(response.message);
        //}
    }


        //点击了搜索按钮
        const onSearchTaskBtn = (e: any) => {
            taskPage.current = 1;
            queryTaskContent.current = e.target.value;
            queryTaskList();
        }
    
        //点击了搜索章节按钮
        const onSearchChapterBtn = (e: any) => {
            chapterPage.current = 1;
            queryChapterContent.current = e.target.value;
            queryChapterList();
        }

    
        // 表格发生变化
        const onTaskTableChange:any = (pagination:any, filters:any, sorter:any, extra: { currentDataSource: [], action: any })=> {
            if (sorter.order) { //如果选择了排序列
                taskOrder.current = sorter.order;
                taskOrderBy.current = sorter.field;
            }
            if (filters.type) { //如果选择了过滤列
                typeFilters.current = filters.type;
            } else {
                typeFilters.current = [];
            }
            if (filters.difficulty) {
                difficultyFilters.current = filters.difficulty;
            } else {
                difficultyFilters.current = [];
            }
            taskPage.current = 1;
            queryTaskList();
        }


    //页码和页数发生了变化
    const onTaskPageChange = (newPage: number, newPageSize?: number | undefined) => {
        taskPage.current = newPage ? newPage : 1;
        if (newPageSize) {
            taskPageSize.current = newPageSize;
        }
        queryTaskList();
    }

    //页码和页数发生了变化
    const onChapterPageChange = (newPage: number, newPageSize?: number | undefined) => {
        chapterPage.current = newPage ? newPage : 1;
        if (newPageSize) {
            chapterPageSize.current = newPageSize;
        }
        queryChapterList();
    }

    // 渲染类型
    const renderType = (text: any, record: any) => (
        <div>{taskTypeMap.get(parseInt(text))}</div>
    )
    
       // 渲染操作
       const renderActions = (text:any, record:any) => {
        if (record.source == 2) {
            return (
                
                        <Link
                            style={{color:"#4f46e5", borderRadius:20,fontSize:14}}
                        
                            id="editit"
                            type="dashed"
                            to = {"/oam_task_edit?task_id="+record.id} > 编辑
                        </Link>
                   
            )
        } else {
            return (
                <Row justify="start" align="middle" gutter={[8, 4]} >
                    <Col span={24}><Button style={{borderRadius:20,fontSize:14}} size='small' id="lookover" value={record.id} type="default" onClick={onLookOverBtnClick.bind(this, record.id)} > 预 览 </Button></Col>
                </Row>
            )
        }
    }

        const task_columns:any = [
              {
                title: '序号',
                dataIndex: 'id',
                key: 'id',
                align: 'center',
                width: 80,
                ellipsis: true,
              },
              {
                title: '任务名称',
                dataIndex: 'title',
                key: 'title',
                ellipsis: true,
                align: 'left',
                width: 150,
                render: (t, r, i) => {
                    return (
                
                        <div  style={{cursor: 'pointer',overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"}} onClick={()=>{window.open("oam_preview_task?task_id=" + r.id)}} >{t}</div>
             
                    )
                },
                

              },
              {
                title: '备注',
                dataIndex: 'remarks',
                key: 'remarks',
                align: 'center',
                width: 100,
                ellipsis: true,
              },
              {
                title: '任务类型',
                dataIndex: 'type',
                key: 'type',
                align: 'center',
                ellipsis: true,
                width: 60,
                
                render: renderType,
                filters: [
                    {
                        text: '实训',
                        value: 1,
                    },
    
                    {
                        text: '纯讲义',
                        value: 6,
                    },
                ],
                onFilter: (value:any, record:any) => true,
              },
              {
                title: '创建者',
                dataIndex: 'creator_name',
                key: 'creator_name',
                width: 180,
                align: 'left',
                render: (t, r, i) => {
                    return (
                    <Row align="middle" justify="start" style={{ gap: '5px' }}>
                        <Col>
                        <img
                            className={GlobalCss.avatar}
                            src={BACKEND_API_URL + r.creator_avatar}
                            alt=""
                        />
                        </Col>
                        <Col>{r.creator_name}</Col>
                    </Row>
                    )
                },
            },
            {
                title: '创建时间',
                dataIndex: 'create_time',
                key: 'create_time',
                width: 200,
                align: 'left',
            },
            /*{
                title: '操作',
                dataIndex: 'actions',
                key: 'actions',
                width: 70,
                align: 'center',
                render: (t, r, i) => {
                    return (
                        <Row justify="center" align="middle" gutter={[8, 5]} wrap={false}>
                        <Col style={{ width: 50 }}>
                        <Button size="small" type="default" style={{borderRadius:3}} onClick={()=>{window.open("oam_preview_task?task_id=" + r.id)}} >预览</Button>
                        </Col>
                        </Row>
          
                        
            

                    )
                },
            },*/
            
          ];

    /**
     * 查询大纲
     */
     const queryMenu = () => {
        sendHttpPostRequest(
            'course/api/oam_query_menu_by_id',
            {
                sessionid: Cookies.get("sessionid"),
                menu_id: menu_id,
            },
            queryMenuCallback
        )
    }
  
    /**
     * 查询大纲回调
     * @param response
     */
    const queryMenuCallback = (response: any) => {
        // console.log(response)
        message.destroy();
        if (response.code == -100) {
            // 未登录
            window.location.href = '/oam_login?next=oam_menu';
        } else if (response.is_ok == true) {
            // 成功
            setMenuName(response.query_info.name);
            setMenuDesp(response.query_info.description);
            setMenuDirectory(response.query_info.json);
            //message.success(response.query_info.name)
           
        } /*else if (response.code == -501) {
            权限不足
            window.location.href = '/oam_login?next=oam_menu';
        } */else {
            message.error(response.message);
        }
    }

     /**
     * 保存大纲
     */
      const saveMenu = () => {
        console.log(menuDirectory)
        sendHttpPostRequest(
            'course/api/oam_update_menu',
            {
                sessionid: Cookies.get("sessionid"),
                menu_id: menu_id,
                name: menuName,
                description: menuDesp,
                json: JSON.stringify(menuDirectory),
            },
            saveMenuCallback
        )
    }
  
    /**
     * 保存大纲回调
     * @param response
     */
    const saveMenuCallback = (response: any) => {
        // console.log(response)
        message.destroy();
        if (response.code == -100) {
            // 未登录
            window.location.href = '/oam_login?next=oam_menu';
        } else if (response.is_ok == true) {
           
            message.success("大纲保存成功~")
           
        } /*else if (response.code == -501) {
            权限不足
            window.location.href = '/oam_login?next=oam_menu';
        } */else {
            message.error(response.message);
        }
    }

    const reorder = (list:any, startIndex:number, endIndex:number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    /**
     * Moves an item from one list to another list.
     */
    const move = (source, destination, droppableSource, droppableDestination) => {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(droppableSource.index, 1);

        destClone.splice(droppableDestination.index, 0, removed);

        const result = {};
        result[droppableSource.droppableId] = sourceClone;
        result[droppableDestination.droppableId] = destClone;

        return result;
    };
    const grid = 4;

    const getItemStyle = (isDragging, draggableStyle) => ({
            userSelect: "none",
            borderRadius:0,
            background: isDragging ? "#eef2ff":'white',
            ...draggableStyle
        });
        const getListStyle = isDraggingOver => ({
            borderRadius:5,
            margin:'auto',
            marginBottom:10,

    });


    function onDragEnd(result) {
        const { source, destination } = result;
    
        // dropped outside the list
        if (!destination) {
          return;
        }
        const sInd = +source.droppableId;
        const dInd = +destination.droppableId;
    
        if (sInd === dInd) {//知识点在同一个章节内排序
          const items = reorder(menuDirectory[sInd].tasks, source.index, destination.index) as Module[];
          const newState = [...menuDirectory];
          newState[sInd].tasks = items
          setMenuDirectory(newState);
        } else {//知识点在不同章节内移动排序
          const result = move(menuDirectory[sInd].tasks, menuDirectory[dInd].tasks, source, destination);
          const newState = [...menuDirectory];
          newState[sInd].tasks = result[sInd];
          newState[dInd].tasks = result[dInd];
          setMenuDirectory(newState);
          
        }
      }


    //点击了查看按钮
  const onLookOverBtnClick = (event:any) => {
    //message.success('查看数据' + event.currentTarget.value)
    event.preventDefault()
    window.open('/oam_menu_detail?menu_id=' + menu_id)
  }

    //点击了保存按钮
    const onSaveBtnClick = (event:any) => {
        saveMenu();
        //history.push("/oam_menu")
    }



    /** 检查当前大纲中是否包含某一个任务 */
    const checkContainsTaskInMenu = (taskId: number | string) => {
        let result = 0;
        menuDirectory?.map((chapter)=>{
            result = result + chapter?.tasks?.filter((item)=>(item.id == taskId)).length;
        })
        console.log(result)
        return result;
    }

    // 更新拉取任务
    const updateTaskInfo = (taskId, taskInd, chapterInd) => {

        const _headers = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}};
        const params = {exercise_id: taskId, sessionid: Cookies.get("sessionid")};
        const url = 'exercise/api/oam_query_task_by_id/';
        const _data = Qs.stringify(params);
        axios
            .post(constants.BACKEND_API_URL + url,
                _data,
                _headers,
            )
            .then((response) => response.data)
            .then((data) => {
                if (data.is_ok) {
                    menuDirectory[chapterInd].tasks[taskInd].name = data.exercise_info?.title
                    setMenuDirectory([...menuDirectory])
                    message.success(taskId+ "信息更新成功~")
                    saveMenu();
                } else {
                    message.error(taskId+ "信息更新失败！")
                }
            })
            .catch((e) => {
                console.log('make http post request error', e);
                message.destroy();
                message.error("服务器请求失败了:(");
            })
    }
    
        // 更新拉取章节
        const updateChapterInfo = (chapterId, chapterInd) => {

            const _headers = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}};
            const params = {chapter_id: chapterId, sessionid: Cookies.get("sessionid")};
            const url = 'course/api/oam_query_chapter_by_id';
            const _data = Qs.stringify(params);
            axios
                .post(constants.BACKEND_API_URL + url,
                    _data,
                    _headers,
                )
                .then((response) => response.data)
                .then((data) => {
                    if (data.is_ok) {
                        menuDirectory[chapterInd].name = data.query_info?.name
                        menuDirectory[chapterInd].description = data.query_info?.description
                        setMenuDirectory([...menuDirectory])
                        saveMenu();
                    } else {
                        console.log(chapterId + "刷新章节失败");
                    }
                })
                .catch((e) => {
                    console.log('make http post request error', e);
                    message.destroy();
                    message.error("服务器请求失败了:(");
                })
        }


    return (
        <div style={{marginTop:0}}>
            <div style={{textAlign:"right",marginBottom:20}}> 
                <Button style={{borderRadius:20,width:80,marginRight:20}} type={'primary'} onClick={onSaveBtnClick}>保 存</Button>
                { /* <Button style={{borderRadius:20,width:80,marginRight:20}} type={'primary'} onClick={onLookOverBtnClick}>预 览</Button>
               <Popconfirm overlayStyle={{width:300}} title="注意，本操作将从章节和任务中提取name和description信息覆盖大纲中的章节名称、章节描述和任务名称。" okText="确认" cancelText="取消" onConfirm={onRefreshMenuInfoBtnClick}><Button style={{borderRadius:20,width:80}} type={'primary'} >刷 新</Button></Popconfirm>*/}
            </div>
            <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>名称</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <Input placeholder="请输入大纲名称" 
                        required={true} 
                        value = {menuName} 
                        onChange={(e)=>{setMenuName(e.target.value)}} 
                        style={{borderRadius:3,width:"100%"}}/>
                    </Col>
                </Row>


                <Row gutter={[8,8]} justify='start'  align='top' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>描述</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <TextArea placeholder="请输入大纲描述" 
                            style = {{borderRadius:3,width:"100%"}} 
                            autoSize = {{minRows: 3}} 
                            value = {menuDesp} 
                            onChange={(e)=>{setMenuDesp(e.target.value)}} 
                        />

                    </Col>
                </Row>

            <div  style={{marginLeft:'auto', marginRight:'auto'}}>
                <DragDropContext  onDragEnd={onDragEnd}> {/*拖拽上下文 */}
                {menuDirectory?.map((chapter, chapterInd) => (
                    <Droppable key={chapterInd} droppableId={`${chapterInd}`}> 
                    {(provided, snapshot) => (
                        <div
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                        {...provided.droppableProps}
                        >  
                             <Row gutter={[0, 4]} justify='start' align='middle' className={myStyles.chapterHeader}>
                                 <Col flex='60px' style={{paddingLeft:10}}>  {  (chapterInd + 1) + "章" }</Col>
                                 <Col flex='auto' style={{overflow: "hidden"}}> {" "}  {menuDirectory[chapterInd].name} </Col>
                                
                                 <Col flex='250px' style={{textAlign:"right",marginRight:10}}> 


                                    
                                    <Button  onClick={()=>{currentChapterInd.current =  chapterInd;showAddTaskModal()}} size="small" style={{marginRight:10, borderRadius:3}} type={'primary'}> + 任 务</Button>
                                    

                                    {/*<Button size="small" type="default" style={{marginRight:10,borderRadius:3}} onClick={()=>{updateChapterInfo(chapter.id,chapterInd)}} >刷新</Button> */}
                                    <Button size="small" type="default" style={{marginRight:10,borderRadius:3, border:"1px solid #4f46e5",color:"#4f46e5"}} onClick={()=>{window.open("/oam_chapter_edit?id="+chapter.id)}} > 编 辑 </Button>
                                    
                                    <Popconfirm placement="top" title={'确认删除章"' + chapter.name + '"吗？'} onConfirm={() => {
                                            const newChapters = [...menuDirectory];
                                            newChapters.splice(chapterInd, 1);
                                            setMenuDirectory(JSON.parse(JSON.stringify(newChapters)));
                                            
                                        }} okText="确认" cancelText="取消">
                                    <CloseCircleOutlined  className= {myStyles.moduleBtn}  style = {{ marginRight: 5}}/>
                                    </Popconfirm> 
                                </Col>
                                 
                             </Row> 
                            
   
                            {chapter.tasks.map((task, taskIndex) => (
                                <DndDraggable
                                key={task.id}
                                draggableId={String(task.id)}
                                index={taskIndex}
                                > 
                                {(provided, snapshot) => (
                                    <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={getItemStyle(
                                        snapshot.isDragging,
                                        provided.draggableProps.style
                                    )}
                                    > 
                                    <div className={myStyles.moduleWrapper} style={{textAlign: "left"}}> {/* 知识点div */}
                                         <Row wrap={false}  gutter={[0, 4]} justify='start' align='middle' className={myStyles.module}>
                                            <Col flex='60px' style={{marginLeft:20,textAlign: "center"}} ><Tooltip title="拖拽排序"><MenuOutlined className= {myStyles.moduleBtn} /></Tooltip> {(chapterInd + 1) + "." + (taskIndex+1)} </Col>
                                            <Col flex="auto"  > <div style={{overflow:"hidden",minWidth:500}}> {" "} {menuDirectory[chapterInd].tasks[taskIndex].name}</div></Col>
                                            
                                            <Col flex="200px" style={{textAlign:"right",marginRight:10}}>
                                                {/*<Button size="small" type="default" style={{marginRight:10,borderRadius:3}} onClick={()=>{updateTaskInfo(task.id,taskIndex,chapterInd)}} >刷新</Button>   */}
                                                <Button size="small" type="default" style={{marginRight:10,borderRadius:3}} onClick={()=>{window.open("task_learn?project/1/chapter/" + chapter.id+ "/task/" + task.id+ "/")}} >预览</Button>
                                                <Button size="small" type="default" style={{marginRight:10,borderRadius:3, border:"1px solid #4f46e5",color:"#4f46e5"}} onClick={()=>{window.open("/oam_task_edit?task_id="+task.id)}} >编辑</Button>
                                                <Popconfirm placement="top" title={'确认删除任务"' + task.id + '"吗？'} onConfirm={() => {
                                                    const newMenuDirectory = [...menuDirectory];
                                                    newMenuDirectory[chapterInd].tasks.splice(taskIndex, 1);
                                                    setMenuDirectory(
                                                        newMenuDirectory.filter(group => group.tasks.length >= 0)
                                                    );
                                                }} okText="确认" cancelText="取消">
                                                
                                                
                                              <CloseCircleOutlined  className= {myStyles.moduleBtn} style = {{ marginRight: 5}} />
                                                 </Popconfirm>  
                                             </Col>

                                         </Row>  
                                      
                                    </div>
                                 </div>
                                )}
                                </DndDraggable>
                            ))}
                            
                            {provided.placeholder}
                        </div>
                    )}
                
                    </Droppable>
                ))}
                </DragDropContext>
            </div>

            <div style={{ textAlign:'right', marginBottom:20}}>
                <Button onClick={showAddChapterModal} className={myStyles.addChapterBtn} style={{width:"100%",height:42,borderRadius:0,marginRight:30}} type="default"> + 添加章</Button> 
            </div>

             <ConfigProvider locale={zhCN}>
                <Modal
                            title={<div
                            style={{
                            width: '100%',
                            cursor: 'move',
                            }}
                            onMouseOver={() => {
                            if (disabled) {
                                setDisabled(false)
                            }
                            }}
                            onMouseOut={() => {
                            setDisabled(true)
                            }}
                            onFocus={() => {}}
                            onBlur={() => {}}
                            // end
                        >
                            添加章
                        </div>
                        }
                        closable={true}
                        open={isAddChapterModalVisible}
                        onOk={handleAddChapterOk}
                        onCancel={handleAddChapterCancel}
                        bodyStyle={{ height:600,overflow:"auto"}}
                        destroyOnClose={true}
                        width={800}
                        modalRender={modal => (<div className={myStyles.createDiv}>
                            <Draggable
                            disabled={disabled}
                            bounds={bounds}
                            onStart={(event, uiData) => onStart(event, uiData)}
                            >
                            <div ref={draggleRef}>{modal}</div>
                            </Draggable> </div>
                        )}
                        >
                            <Input 
                                placeholder="搜索章" 
                                onPressEnter={onSearchChapterBtn}
                                style={{float:'left',borderRadius:20,width:300,marginBottom:10}} 
                                suffix={<SearchOutlined  style={{color:"#666666"}}/>}
                            >

                            </Input>
                            
                            <div className={idataCodingTableStyles.tableWrapper}>
                            <ConfigProvider locale={zhCN}>
                                <Table
                                    dataSource={chapterResult}
                                    columns={chapter_cols}
                                    rowKey={record => record.id}
                                    size="small"
                                    pagination={false}
                                    rowSelection={{
                                        type: "radio",
                                        ...rowChapterSelection,
                                      }}
                                // bordered={true}
                                    //onChange={onTableChange}
                                />
                            </ConfigProvider>
                            </div>
                        
                            <ConfigProvider locale={zhCN}>
                            <div style={{marginBottom:30,paddingTop:30,textAlign:"center"}} className={"css.pagination"} >
                                <Pagination
                                    defaultCurrent={1}
                                    total={chapterResultSum}
                                    defaultPageSize={10}
                                    hideOnSinglePage={true}
                                    current={chapterPage.current}
                                    onChange={onChapterPageChange}
                                    //showQuickJumper={true}
                                    showTotal={total => `找到 ${total} 章节`}
                                    showSizeChanger={false}
                                />
                            </div>
                        </ConfigProvider>

                    </Modal>
                </ConfigProvider>


                <ConfigProvider locale={zhCN}>
                    <Modal
                            title={<div
                            style={{
                            width: '100%',
                            cursor: 'move',
                            }}
                            onMouseOver={() => {
                            if (disabled) {
                                setDisabled(false)
                            }
                            }}
                            onMouseOut={() => {
                            setDisabled(true)
                            }}
                            onFocus={() => {}}
                            onBlur={() => {}}
                            // end
                        >
                            添加任务
                        </div>
                        }
                        closable={true}
                        open={isAddTaskModalVisible}
                        onOk={handleAddTaskOk}
                        onCancel={handleAddTaskCancel}
                        bodyStyle={{ height:600}}
                        destroyOnClose={true}
                        width={900}
                        modalRender={modal => (<div className={myStyles.createDiv}>
                            <Draggable
                            disabled={disabled}
                            bounds={bounds}
                            onStart={(event, uiData) => onStart(event, uiData)}
                            >
                            <div ref={draggleRef}>{modal}</div>
                            </Draggable> </div>
                        )}
                    >
                                         
                    <Input
                        onPressEnter={onSearchTaskBtn} 
                        placeholder="搜索任务" 
                        style={{float:'left',borderRadius:20,width:300,marginBottom:10}} 
                        suffix={<SearchOutlined  style={{color:"#666666"}}/>}
                    />
                            <div className={idataCodingTableStyles.tableWrapper}>
                                <ConfigProvider locale={zhCN}>
                                    <Table
                                        dataSource={taskListResult}
                                        columns={task_columns}
                                        rowKey={record => record.id}
                                        pagination={false}
                                        size="small"
                                        //scroll={{ x: 600 }}
                                        //bordered={true}
                                        onChange={onTaskTableChange}
                                        rowSelection={{
                                            type: "checkbox",
                                            ...rowTaskSelection,
                                          }}
                                    />
                                </ConfigProvider>
                                </div>


                        <ConfigProvider locale={zhCN}>
                            <div style={{marginBottom:30,paddingTop:30,textAlign:"center"}} className={"css.pagination"} >
                                <Pagination
                                    defaultCurrent={1}
                                    total={taskResultSum}
                                    defaultPageSize={10}
                                    hideOnSinglePage={true}
                                    current={taskPage.current}
                                    onChange={onTaskPageChange}
                                    //showQuickJumper={true}
                                    showTotal={total => `找到 ${total} 任务`}
                                    showSizeChanger={false}
                                />
                            </div>
                        </ConfigProvider>
                        
                    </Modal>
                </ConfigProvider>
            </div>
    )
}

export default MenuEdit

